import { useMemo } from "react";
import { isFeatureAvailable, Feature } from "@functions/featureAvailability";
import { useCurrentWorkspaceUsage } from "@/store";

export const useVisibilityThroughWorkspace = () => {
    const currentWorkspaceUsage = useCurrentWorkspaceUsage();

    const visibilityThroughWorkspace = useMemo(() => {
        const privateDataThroughWorkspace =
            currentWorkspaceUsage &&
            isFeatureAvailable(Feature.PrivateProjects, currentWorkspaceUsage);
        return privateDataThroughWorkspace ? "private" : "public";
    }, [currentWorkspaceUsage]);

    return visibilityThroughWorkspace;
};
